/** 异步初始化与卸载相交时，资源只能发布或销毁一次。 */
export class AsyncResource<T> {
    private pending?: Promise<T | undefined>;
    private value?: T;
    private disposed = false;

    constructor(
        private readonly create: () => Promise<T>,
        private readonly destroy: (value: T) => void,
    ) {}

    get(): Promise<T | undefined> {
        if (this.disposed) return Promise.resolve(undefined);
        if (!this.pending) {
            this.pending = this.create()
                .then((value) => {
                    if (this.disposed) {
                        this.destroy(value);
                        return undefined;
                    }
                    this.value = value;
                    return value;
                })
                .catch((error) => {
                    this.pending = undefined;
                    throw error;
                });
        }
        return this.pending;
    }

    dispose() {
        if (this.disposed) return;
        this.disposed = true;
        if (this.value !== undefined) this.destroy(this.value);
        this.value = undefined;
    }
}
